$(function() {
  const productContainer = $('.product');
  const modalTriggers = $('.lyric-modal-trigger');

  $(modalTriggers).each(function(){
    const lyricModal = $(this).siblings('.lyric-modal');
    const modalClose = $(lyricModal).find('.lyric-modal-close');
    $(lyricModal).hide();
    $('body').append(lyricModal);
  
    $(this).on('click', function(e){
      e.stopPropagation();
      $(lyricModal).show(100);
    });

    $(modalClose).on('click', function(){
     $(lyricModal).hide(100); 
    });

    $(document).on("click", function(e){
      if (!lyricModal.is(e.target) && lyricModal.has(e.target).length === 0) {
        $(lyricModal).hide(100);
      }
    });
    
  })
})